<template>
  <b-modal ref="driverCompany-card-modal" @ok="driverCompanyCardModalOk">
    <template v-slot:modal-header="{}">
      <div>{{ $store.state.localization.data.mainPage.azk.driverCompanies.pageLabel }}</div>
    </template>
    <div style="font-size: 13px">
      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.driverCompanies.tableColumns.companyName"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="companyName"
          :state="isCompanyNameValid"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.driverCompanies.tableColumns.codeEdrpou"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="codeEdrpou"
          :state="isCodeEdrpouValid"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.driverCompanies.tableColumns.filia"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="filia"
          :state="isFiliaValid"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.driverCompanies.tableColumns.unit"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="unit"
          :state="isUnitValid"
          style="font-size: 13px"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.common.created"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="created"
          style="font-size: 13px"
          readonly
        ></b-form-input>
      </b-form-group>

      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.common.updated"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="updated"
          style="font-size: 13px"
          readonly
        ></b-form-input>
      </b-form-group>
      <b-form-group
        label-cols-sm="4"
        label-cols-lg="3"
        content-cols-sm
        content-cols-lg="8"
        :label="$store.state.localization.data.mainPage.azk.users.tableColumns.userName"
        label-for="input-horizontal"
      >
        <b-form-input
          v-model="driverCompany.executor"
          style="font-size: 13px"
          readonly
        ></b-form-input>
      </b-form-group>
    </div>
    <template v-slot:modal-footer="{ ok, cancel }">
      <b-button variant="success" style="font-size: 12px" @click="ok()">{{
        $store.state.localization.data.common.table.ok
      }}</b-button>
      <b-button variant="light" style="font-size: 12px" @click="cancel()">{{
        $store.state.localization.data.common.table.cancel
      }}</b-button>
    </template>
  </b-modal>
</template>

<script>

import { utilsService, azkService } from "../../../../services";

export default {
  name: "UpdateDriverCompanyPage",
  props: {
    driverCompany: Object,
  },
  components: {},
  data() {
    return {
      companyName: null,
      codeEdrpou: null,
      filia: null,
      unit: null,

      isCompanyNameValid: null,
      isCodeEdrpouValid: null,
      isFiliaValid: null,
      isUnitValid: null,
      created: null,
      updated: null
    };
  },
  methods: {
    async open() {
      this.isCompanyNameValid = null;
      this.isCodeEdrpouValid = null;
      this.isFiliaValid = null;
      this.isUnitValid = null;

      this.companyName = this.driverCompany.companyName;
      this.codeEdrpou = this.driverCompany.codeEdrpou;
      this.filia = this.driverCompany.filia;
      this.unit = this.driverCompany.unit;

      this.created = utilsService.formatDateTime(new Date(this.driverCompany.created * 1000), utilsService.DATE_TIME_FORMAT);
      this.updated = utilsService.formatDateTime(new Date(this.driverCompany.updated * 1000), utilsService.DATE_TIME_FORMAT);

      this.$refs["driverCompany-card-modal"].show();
    },
    validate() {
      let isValid = true;

      if (!this.companyName) {
        this.isCompanyNameValid = false;
        isValid = false;
      } else {
        this.isCompanyNameValid = null;
      }

      if (!this.codeEdrpou) {
        this.isCodeEdrpouValid = false;
        isValid = false;
      } else {
        this.isCodeEdrpouValid = null;
      }

      if (!this.filia) {
        this.isFiliaValid = false;
        isValid = false;
      } else {
        this.isFiliaValid = null;
      }

      if (!this.unit) {
        this.isUnitValid = false;
        isValid = false;
      } else {
        this.isUnitValid = null;
      }

      return isValid;
    },
    async driverCompanyCardModalOk(event) {
      if (!this.validate()) {
        event.preventDefault();
        return;
      }

      this.driverCompany.companyName = this.companyName;
      this.driverCompany.codeEdrpou = this.codeEdrpou;
      this.driverCompany.filia = this.filia;
      this.driverCompany.unit = this.unit;
    
      const updateDriverCompanyResponse = await azkService.updateCompany(this.driverCompany);

      if (
        updateDriverCompanyResponse.isSuccess &&
        updateDriverCompanyResponse.data &&
        updateDriverCompanyResponse.data.countInsertedRows == 1
      ) {
        this.$emit("driverCompanyUpdatedSuccessEvent", this.driverCompany);
      } else {
        this.$emit("driverCompanyUpdatedFailEvent");
      }
    },
  },
};
</script>
